const NewRoute = () => <h1>NEW ROUTE</h1>

export default NewRoute